import React, { useState } from 'react';
import { Box, TextField, Button, Typography, CircularProgress } from '@mui/material';
import AuthService from '../services/authService';

const Login = ({ isMobile, setUserSystem }) => {
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async () => {
        // Validación básica
        if (!phone || !password) {
            setError('Por favor completa todos los campos');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await AuthService.login(phone, password);

            // Si el login es exitoso, actualizar el estado del usuario
            if (response.success) {
                const storedUser = localStorage.getItem('userSystem');
                if (storedUser) {
                    setUserSystem(JSON.parse(storedUser));
                }
            }
        } catch (err) {
            setError(err.message || 'Error al iniciar sesión');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                width: '100%',
                padding: 2,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: 'center',
                    padding: 2,
                    backgroundColor: '#202c33',
                }}
            >
                <TextField
                    variant="outlined"
                    placeholder="Número de Teléfono"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    error={!!error}
                    sx={{
                        width: isMobile ? '100%' : '40%',
                        color: '#fff',
                        borderRadius: '10px',
                        backgroundColor: '#2a3942',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: '10px',
                            color: '#fff',
                        },
                        marginBottom: isMobile ? '10px' : 0,
                    }}
                />
                <TextField
                    variant="outlined"
                    type="password"
                    placeholder="Contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={!!error}
                    sx={{
                        marginLeft: !isMobile ? '20px' : "0",
                        width: isMobile ? '100%' : '40%',
                        color: '#fff',
                        borderRadius: '10px',
                        backgroundColor: '#2a3942',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: '10px',
                            color: '#fff',
                        },
                        marginBottom: isMobile ? '10px' : 0,
                    }}
                />
                <Button
                    onClick={handleLogin}
                    disabled={loading}
                    sx={{
                        marginTop: isMobile ? '10px' : '0',
                        border: '1px solid #fff',
                        width: isMobile ? '100%' : '20%',
                        marginLeft: 1,
                        background: "none",
                        padding: 1.3,
                        '&:hover': {
                            background: 'rgba(255, 255, 255, 0.1)',
                        },
                    }}
                >
                    {loading ? (
                        <CircularProgress size={24} sx={{ color: '#fff' }} />
                    ) : (
                        <Typography sx={{
                            color: '#fff',
                            fontSize: '0.85rem',
                        }}>
                            Iniciar Sesión
                        </Typography>
                    )}
                </Button>
            </Box>
            {error && (
                <Box
                    sx={{
                        marginTop: 3,
                        border: '1px solid #f00',
                        backgroundColor: '#202c33',
                    }}
                >
                    <Typography
                        sx={{
                            color: '#fff',
                            fontSize: isMobile ? '0.8rem' : '1rem',
                            padding: 1,
                            width: '100%',
                            textAlign: 'center',
                        }}
                    >
                        {error}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default Login;